/**
 * @fileoverview POST handler for the "/engagement/content_blocks/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { engagementContentBlocksUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementContentBlocksUpdateArchivedStateProps,
  EngagementContentBlocksUpdateArchivedStateSuccessResult,
  ContentBlockArchiveError,
} from "./types";

export const postEngagementContentBlocksUpdateArchivedState = reactQueryMutationAdapter(
  engagementContentBlocksUpdateArchivedStateCacheKeys,
  createMutationFetcherFunctionWithShadowError<ContentBlockArchiveError>()(
    ({
      ids,
      mark_as_archived,
      undo_identifier,
    }: PostEngagementContentBlocksUpdateArchivedStateProps): Promise<EngagementContentBlocksUpdateArchivedStateSuccessResult> => {
      return fetch(
        "/engagement/content_blocks/update_archived_state",
        "POST",
        {
          ids,
          mark_as_archived,
          undo_identifier,
        },
        undefined,
        { propagateFetchRequestError: false }
      ).then((result) => {
        return { ...result, undo_data: { ...result.undo_data, reenable: [] } };
      });
    }
  )
);
